interface PartialLocalStorage extends Pick<Storage, 'getItem' | 'setItem' | 'clear' | 'removeItem'> {}

let db: Record<string, string | undefined> = {};

export class InMemoryLocalStorage implements PartialLocalStorage {
    getItem(key: string): string | null {
        return db[key] ?? null;
    }

    setItem(key: string, value: string): void {
        db[key] = value;
    }

    clear(): void {
        db = {};
    }

    removeItem(key: string): void {
        db[key] = undefined;
    }
}

export const isLocalStorageAvailable = () => {
    try {
        localStorage.setItem('TEST_KEY', 'TEST_VALUE');
        localStorage.getItem('TEST_KEY');
        localStorage.removeItem('TEST_KEY');
        return true;
    } catch {
        return false;
    }
};

const storage = isLocalStorageAvailable() ? localStorage : new InMemoryLocalStorage();

class SafeLocalStorage implements PartialLocalStorage {
    getItem(key: string): string | null {
        return storage.getItem(key);
    }

    setItem(key: string, value: string): void {
        storage.setItem(key, value);
    }

    clear(): void {
        storage.clear();
    }

    removeItem(key: string): void {
        storage.removeItem(key);
    }
}

const safeLocalStorage = new SafeLocalStorage();

export { safeLocalStorage };
